import React, {useCallback} from 'react';
import {Layout, Icon, Spacer} from '../..';
import {Text} from '../../text';

type SimpleDropdownItemProps = {
  index: number;
  isActive: boolean;
  title: string;
  badge?: React.ReactElement | null;
  onSelectedIndexChange?: (index: number) => void;
};

export const SimpleDropdownItem: React.FC<SimpleDropdownItemProps> = ({
  index,
  title,
  isActive,
  badge,
  onSelectedIndexChange,
}) => {
  const onSelected = useCallback(() => {
    onSelectedIndexChange && onSelectedIndexChange(index);
  }, [index, onSelectedIndexChange]);
  return (
    <Layout
      flex
      horizontal
      hover
      backgroundColor={isActive ? 'background_mono_tertiary' : undefined}
      onPress={onSelected}
      align="center"
      paddingHorizontal={'16'}
      paddingVertical={'10'}>
      {/** Render badge or icon */}
      {badge}
      {/** Render text */}
      <Layout flex align="center">
        <Text variant={isActive ? 'inline_14_emphasis' : 'inline_14_default'}>
          {title}
        </Text>
      </Layout>
      {/** Render active checkmark */}
      {isActive && (
        <Layout align="center">
          <Icon name={'checkmarkSmall'} />
          <Spacer width="8" />
        </Layout>
      )}
    </Layout>
  );
};
